/**
 * botNoFeedRetreat — fountain dump at 20%, no-feed at 40% vs nearby champs (FID-BOT-16 / patch-20).
 *
 * Pure JS — no Three.js, no DOM.
 */

export const BOT_FOUNTAIN_RETREAT_HP = 0.20;
export const BOT_NO_FEED_HP = 0.40;

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

function distance2d(a, b) {
  return Math.hypot(b.x - a.x, entityZ(b) - entityZ(a));
}

function isEnemyChampion(entity, team) {
  if (!entity || entity.isDead) return false;
  if (entity.team === team) return false;
  return entity.type === 'champion';
}

export function enemyChampionInRadius(bot, allEntities = [], radius = 0) {
  if (!bot || !(radius > 0)) return false;
  for (const entity of allEntities) {
    if (!isEnemyChampion(entity, bot.team)) continue;
    if (distance2d(bot, entity) <= radius) return true;
  }
  return false;
}

export function shouldRetreatToFountain(bot, allEntities = [], visionRadius = 0) {
  if (!bot) return false;
  const ratio = bot.hp / (bot.maxHp || 1);
  if (ratio < BOT_FOUNTAIN_RETREAT_HP) return true;
  if (ratio < BOT_NO_FEED_HP && enemyChampionInRadius(bot, allEntities, visionRadius)) {
    return true;
  }
  return false;
}
